<template>
  <b-container fluid class="py-4 px-4">
    <GlobalActivityFeed />
  </b-container>
</template>

<script>
import GlobalActivityFeed from '@/components/GlobalActivityFeed.vue';

export default {
  components: {
    GlobalActivityFeed,
  },
};
</script>
